import { View } from 'react-native'
import { router } from 'expo-router'
import { useTranslation } from 'react-i18next'
import SectionRow from '@ui/elements/SectionRow'
import Button from '@ui/buttons/Button'
import useCustomerInvoice from 'hooks/useCustomerInvoice'
import { useConfigCondition } from 'features/config/useConfigCondition'
import { ORDER_HISTORY } from 'features/config/ConfigConditionSchemas'
import { ModalSetter } from './types'

interface Props {
  setModal: ModalSetter
}

export default function CustomerAccountList({ setModal }: Props) {
  const { t } = useTranslation(['ui', 'modals'])

  useCustomerInvoice()

  const openCreditsModal = () => setModal('credits')
  const showOrderHistory = useConfigCondition(ORDER_HISTORY)

  return (
    <>
      <View className="mt-8 flex w-full px-8">
        <View className="w-full flex-col gap-0 overflow-hidden rounded-xl border border-black/10">
          {showOrderHistory && (
            <SectionRow
              index={0}
              icon="shopping-bag-outlined"
              isGrouped
              title={t('order:history.header.title')}
              onPress={() => router.push('/customer/order/history')}
              actionComponent={
                <Button
                  size="xs"
                  variant="outlined"
                  label={t('ui:view')}
                  noninteractive
                />
              }
            />
          )}
          <SectionRow
            index={showOrderHistory ? 1 : 0}
            icon="coin"
            isGrouped
            title={t('modals:credits.title')}
            onPress={openCreditsModal}
            actionComponent={
              <Button
                size="xs"
                variant="outlined"
                label={t('ui:view')}
                noninteractive
              />
            }
          />
        </View>
      </View>
    </>
  )
}
